import template_json from './template.v2.json' with { type: "json" };
import { getLibauthCompiler } from '@unspent/tau';
export default class Future {
    static compiler = getLibauthCompiler(template_json);
}
//# sourceMappingURL=auth.js.map